import currentYear from "../common/get-current-year";
import scrollReveal from "../common/scroll-reveal";
import setNbsp from "../common/set-nbsp";
import setSvgSize from "../common/set-svg-size";

export default function routingFunctions() {
  currentYear();
  setNbsp();
  setSvgSize();
  scrollReveal();
}